import axios from "axios";
import { useCookies } from "vue3-cookies";

const { cookies } = useCookies();

const API_HOST = process.env.VUE_APP_APIHOST;
const VERSION = "api/v1";
const ADMIN_BY_USERNAME = `${API_HOST}/${VERSION}/admins/get_admin_by_username/`;

const USER_KEY = "CPuser";

export const setUser = (user) => {
  localStorage.setItem(USER_KEY, JSON.stringify(user));
};

export const removeUser = () => {
  localStorage.removeItem(USER_KEY);
};

export const getUser = () => {
  try {
    return JSON.parse(localStorage.getItem(USER_KEY));
  } catch (error) {
    return null;
  }
};

const fetchUser = async () => {
  const username = cookies.get("CPusername");
  const token = cookies.get("CPsession");

  if (!username || !token) {
    return null;
  }

  var data = new FormData();
  data.append("username", username);

  try {
    const response = await axios.post(ADMIN_BY_USERNAME, data, {
      headers: { Authorization: "Token " + token },
    });
    const user = response?.data?.user || null;

    if (user) {
      setUser(user);
    }

    return user;
  } catch (error) {
    return null;
  }
};

// Fills in the logged in user data when it is not in localStorage yet
// (e.g. a session started before permission checking was introduced).
export const ensureUser = async () => {
  return getUser() || (await fetchUser());
};

export const isDenied = (modelPermission) => {
  const user = getUser();

  // No user data - do not block, the backend returns 403 anyway.
  if (!user) {
    return false;
  }

  if (user.is_superuser) {
    return false;
  }

  return !(user.permissions || []).includes(modelPermission.value);
};

export const hasPermission = (modelPermission) => !isDenied(modelPermission);

// Site scoped permissions. user.site_permissions is a map of
// { site_pk: ["app_label.codename", ...] } - for a superuser the backend
// returns every site with an empty permission list.
export const getPermittedSiteIds = (modelPermission) => {
  const user = getUser();

  if (!user || !user.site_permissions) {
    return [];
  }

  const siteIds = new Set();

  if (user.is_superuser) {
    Object.keys(user.site_permissions).forEach((id) => {
      siteIds.add(parseInt(id, 10));
    });

    return [...siteIds];
  }

  // The user always sees their own site, plus every site the permission
  // was granted on.
  if (user.site) {
    siteIds.add(parseInt(user.site, 10));
  }

  Object.entries(user.site_permissions).forEach(([id, permissions]) => {
    const granted = (permissions || []).some((permission) =>
      String(permission).includes(modelPermission.value)
    );

    if (granted) {
      siteIds.add(parseInt(id, 10));
    }
  });

  return [...siteIds];
};
